import { render } from "./MyClients.vue?vue&type=template&id=dc2d2d94&scoped=true"
import script from "./MyClients.vue?vue&type=script&lang=js"
export * from "./MyClients.vue?vue&type=script&lang=js"

import "./MyClients.vue?vue&type=style&index=0&id=dc2d2d94&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2d2d94"]])

export default __exports__